<template>
  <div class="basic-footer flex justify-center items-center">
    <div class="footer-text">© 2025 ARTFIELD</div>
  </div>
</template>

<style scoped>
.basic-footer {
  padding: 24px 0;
  border-top: 1px solid black;
  margin-top: 20px;
}
.footer-text {
  font-size: 16px;
  line-height: 1;
  color: black;
}
</style>